import get from 'lodash.get';

const getMultilingualIntroShown = (rootState) =>
  get(rootState, 'ws.site.properties.multilingualIntroShown', false);

export default getMultilingualIntroShown;
